import { createFileRoute } from "@tanstack/react-router";
import { ClinicalPageShell } from "@/components/clinical";
import { CrudShellHeader } from "@/components/ds";
import { BulkPriceAdjustPanel } from "@/components/catalog/BulkPriceAdjustPanel";
import { useWorkspaceTenantId } from "@/hooks/use-workspace-tenant-id";

export const Route = createFileRoute("/app/catalogacion/precios")({
  component: CatalogacionPreciosPage,
  head: () => ({ meta: [{ title: "Ajuste de precios — Catalogación" }] }),
});

function CatalogacionPreciosPage() {
  const tid = useWorkspaceTenantId();

  return (
    <div>
      <CrudShellHeader title="Ajuste de precios" backHref="/app/catalogacion" backLabel="Volver a Catalogación" />
      <ClinicalPageShell offset="none" className="pt-6">
        {tid ? (
          <div className="mt-4">
            <BulkPriceAdjustPanel tenantId={tid} />
          </div>
        ) : null}
      </ClinicalPageShell>
    </div>
  );
}
